import React from 'react';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { Plus, Trash2 } from 'lucide-react';

interface ServiceItem {
  id: string;
  name: string;
  baseCost: string;
}

interface ServicesStepProps {
  items: ServiceItem[];
  onChange: (items: ServiceItem[]) => void;
}

export function ServicesStep({ items, onChange }: ServicesStepProps) {
  const addRow = () => {
    onChange([...items, { id: crypto.randomUUID(), name: '', baseCost: '' }]);
  };

  const removeRow = (id: string) => {
    onChange(items.filter(s => s.id !== id));
  };

  const updateRow = (id: string, field: 'name' | 'baseCost', value: string) => {
    onChange(items.map(s => s.id === id ? { ...s, [field]: value } : s));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Aggiungi i servizi fotografici che offri. Potrai modificarli in qualsiasi momento.
      </p>

      {items.map((svc) => (
        <div key={svc.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <Input label="Nome servizio" value={svc.name}
              onChange={e => updateRow(svc.id, 'name', e.target.value)}
              placeholder="Fotografia base" />
          </div>
          <div style={{ width: '10rem' }}>
            <Input label="Prezzo base (€)" type="number" value={svc.baseCost}
              onChange={e => updateRow(svc.id, 'baseCost', e.target.value)}
              placeholder="500" />
          </div>
          <button onClick={() => removeRow(svc.id)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--color-text-muted)', padding: '0.5rem', marginBottom: '2px'
          }}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}

      <Button variant="ghost" onClick={addRow} icon={<Plus size={14} />} style={{ alignSelf: 'flex-start' }}>
        Aggiungi servizio
      </Button>
    </div>
  );
}
